import { t } from "@lingui/macro"

export const KNOWLEDGE_TYPES = [
    {
        value: "file",
        get label() {
            return t`knowledge-item-modal.type-file`
        },
        createAllowed: true,
    },
    {
        value: "page",
        get label() {
            return t`knowledge-item-modal.type-page`
        },
        createAllowed: true,
    },
    {
        value: "web",
        get label() {
            return t`knowledge-item-modal.type-web-search`
        },
        createAllowed: true,
    },
    {
        value: "information_item",
        get label() {
            return t`knowledge-item-modal.type-information-item`
        },
        createAllowed: false,
    },
    {
        value: "notice_board_message",
        get label() {
            return t`knowledge-item-modal.type-notice-board-message`
        },
        createAllowed: false,
    },
]

// Display labels for knowledge item types in list views
export const KNOWLEDGE_TYPE_DISPLAY_LABELS = [
    {
        value: "file",
        get label() {
            return t`knowledge-base-list-view.type-file-display`
        },
    },
    {
        value: "page",
        get label() {
            return t`knowledge-base-list-view.type-page-display`
        },
    },
    {
        value: "web",
        get label() {
            return t`knowledge-base-list-view.type-web-display`
        },
    },
    {
        value: "information_item",
        get label() {
            return t`knowledge-base-list-view.type-information-item-display`
        },
    },
    {
        value: "notice_board_message",
        get label() {
            return t`knowledge-base-list-view.type-notice-board-display`
        },
    },
]
